export default __webpack_public_path__ + "img/catIcon13093.c4891e59.svg";